module.exports = __webpack_public_path__ + "media/images/safari-pinned-tab-3bd11fc926d35387cf5403d8c1c3ef0e.svg";